/**
 * Wer in der Fahrerauswahl steht — beim Eintragen (AuftragAnlegen) und beim
 * Bearbeiten (AuftragSeite) dieselbe Liste.
 *
 * ═══ OHNE APP: WÄHLBAR, ABER HINTEN (HJ-011) ═══
 *
 * Seit HJ-011 ist ein Fahrer ab dem Anlegen aktiv, nicht erst nach dem
 * Einlösen des Codes. Ihn auszublenden wäre falsch: Wer am Montag anfängt,
 * bekommt seine erste Tour oft schon am Freitag — sie liegt bereit, sobald er
 * den Code eingibt. Ihn gleichrangig zu zeigen wäre auch falsch: Dann geht
 * eine Tour an jemanden, der sie auf keinem Telefon sieht, und niemand merkt
 * es. Deshalb hinten, mit dem Grund im Text — eine Option kann keinen
 * Hinweis darunter tragen.
 *
 * Eigene Datei ohne Supabase, damit `npm run logik` sie prüfen kann
 * (`pruefung/fahrerwahl.test.ts`).
 */

export type Fahrerperson = {
  id: string;
  vorname: string;
  nachname: string;
  rolle: string;
  status: string;
  auth_user_id: string | null;
};

export type Fahrerwahl = { id: string; text: string; ohneApp: boolean };

export function fahrerZurWahl(leute: Fahrerperson[]): Fahrerwahl[] {
  const nachName = (a: Fahrerperson, b: Fahrerperson) =>
    a.nachname.localeCompare(b.nachname, 'de') || a.vorname.localeCompare(b.vorname, 'de');
  const fahrer = leute.filter((m) => m.rolle === 'fahrer' && m.status === 'aktiv');
  const mitApp = fahrer.filter((m) => m.auth_user_id !== null).sort(nachName);
  const ohneApp = fahrer.filter((m) => m.auth_user_id === null).sort(nachName);

  return [
    ...mitApp.map((m) => ({ id: m.id, text: `${m.vorname} ${m.nachname}`, ohneApp: false })),
    ...ohneApp.map((m) => ({
      id: m.id,
      text: `${m.vorname} ${m.nachname} – App noch nicht eingerichtet`,
      ohneApp: true,
    })),
  ];
}
